export default __webpack_public_path__ + "static/media/3.4132f2c4.png";